import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import { DeleteOutlined, FileDownloadOutlined } from '@mui/icons-material';
import React from 'react';
import { Palette } from 'Palette';
import { StyledTypography } from '../styles/styles';
import type { IRRUpdate } from '../../models/IRRUpdate';

export function CashflowReportRows({
  reports,
  downloadingId,
  onDownload,
  onDelete,
}: {
  reports: IRRUpdate[];
  downloadingId: string | null;
  onDownload: (report: IRRUpdate) => void;
  onDelete: (report: IRRUpdate) => void;
}) {
  if (reports.length === 0) {
    return (
      <StyledTypography sx={{ textAlign: 'center', p: 2 }}>
        No cashflow reports uploaded yet.
      </StyledTypography>
    );
  }
  return (
    <Box>
      {reports.map((report) => (
        <Box
          key={report.id}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            py: 1,
            borderBottom: `1px solid ${Palette.default.border}`,
          }}
        >
          <StyledTypography>{report.label}</StyledTypography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title="Download">
              <span>
                <IconButton
                  size="small"
                  disabled={downloadingId === report.id}
                  onClick={() => onDownload(report)}
                >
                  {downloadingId === report.id ? (
                    <CircularProgress size={18} />
                  ) : (
                    <FileDownloadOutlined fontSize="small" />
                  )}
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                size="small"
                onClick={() => onDelete(report)}
                sx={{ color: Palette.warning.buttonBg }}
              >
                <DeleteOutlined fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
